// global-captcha-gate.tsx — 全局 CaptchaModal 宿主(2026-05-28 plan §6 fix-1)。
//
// 挂在 main.tsx 根部,订阅 captchaBroker;任何上传入口收到 428 后
// (uploadFile 未传 onCaptchaRequired 时回落到 broker.request),
// 本组件自动弹出 captcha modal,完成后 resolve 给上传器。
//
// 2026-06-06 fix(多文件并发 captcha 第二张失败):
//   open / key 直接从 broker 状态派生,而非靠 modal 回调切 boolean:
//     - open = pending()>0       —— 还有排队请求就保持打开
//     - key  = serial()          —— 队首切到下一个请求时 key 变 → CaptchaModal 重挂载
//                                   → 必拉一张新 challenge(修旧题复用 / "刷新不及时")
//   onVerified 只 resolve(成功);onClose 才 cancelHead(用户主动放弃)。详见 captcha-broker.ts。

import { useEffect, useState } from 'react'
import { CaptchaModal } from '@dogdisk/shared'
import { captchaBroker } from '../_lib/captcha-broker'

export function GlobalCaptchaGate() {
  const [pending, setPending] = useState(0)
  const [serial, setSerial] = useState(0)

  useEffect(() => {
    const unsub = captchaBroker.subscribe(() => {
      setPending(captchaBroker.pending())
      setSerial(captchaBroker.serial())
    })
    return unsub
  }, [])

  return (
    <div data-testid="global-captcha-gate">
      <CaptchaModal
        key={serial}
        open={pending > 0}
        onClose={() => captchaBroker.cancelHead()}
        onVerified={(tokens) => captchaBroker.resolve(tokens[0] ?? '')}
      />
    </div>
  )
}
